var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-page---New-layout-V3",
    transform: "translate(-159.000000, -243.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-24px",
    transform: "translate(159.000000, 243.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 23 0 23 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333333,11 C16.9241667,11 18.19875,9.66 18.19875,8 C18.19875,6.34 16.9241667,5 15.3333333,5 C13.7425,5 12.4583333,6.34 12.4583333,8 C12.4583333,9.66 13.7425,11 15.3333333,11 Z M7.66666667,11 C9.2575,11 10.5320833,9.66 10.5320833,8 C10.5320833,6.34 9.2575,5 7.66666667,5 C6.07583333,5 4.79166667,6.34 4.79166667,8 C4.79166667,9.66 6.07583333,11 7.66666667,11 Z M7.66666667,13 C5.43375,13 0.958333333,14.17 0.958333333,16.5 L0.958333333,18 C0.958333333,18.55 1.38958333,19 1.91666667,19 L13.4166667,19 C13.94375,19 14.375,18.55 14.375,18 L14.375,16.5 C14.375,14.17 9.89958333,13 7.66666667,13 Z M15.3333333,13 C15.0554167,13 14.7391667,13.02 14.40375,13.05 C14.4229167,13.06 14.4325,13.08 14.4420833,13.09 C15.5345833,13.92 16.2916667,15.03 16.2916667,16.5 L16.2916667,18 C16.2916667,18.35 16.2245833,18.69 16.1191667,19 L21.0833333,19 C21.6104167,19 22.0416667,18.55 22.0416667,18 L22.0416667,16.5 C22.0416667,14.17 17.56625,13 15.3333333,13 Z",
    id: "Shape",
    fill: "#616674"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientView);
export default __webpack_public_path__ + "static/media/client-view.b545475003721e9dd133a29340092c8b.svg";
export { ForwardRef as ReactComponent };